import React, { useId } from 'react';
import { visuallyHidden } from '@noths/polaris-client-styles';

import type { InspirationCardProps } from 'src/components/molecules/InspirationCard/InspirationCard';
import { InspirationCard } from 'src/components/molecules/InspirationCard/InspirationCard';
import * as styles from './InspirationCategoryCarousel.styles';

export interface InspirationCategoryCarouselProps {
  heading: string;
  href: string;
  posts: InspirationCardProps[];
}

/** A category's latest posts in one swipeable row, linking on to the full category page. */
export const InspirationCategoryCarousel = ({
  heading,
  href,
  posts,
}: InspirationCategoryCarouselProps) => {
  const headingId = useId();

  return (
    <section aria-labelledby={headingId} css={styles.root}>
      <div css={styles.header}>
        <h2 css={styles.heading} id={headingId}>
          {heading}
        </h2>
        <a css={styles.seeMore} href={href}>
          See more<span css={visuallyHidden}> {heading} posts</span>
        </a>
      </div>
      <ul css={styles.track}>
        {posts.map((post) => (
          <li css={styles.item} key={post.href}>
            <InspirationCard {...post} />
          </li>
        ))}
      </ul>
    </section>
  );
};
